/* A quantity box on a product page must never be blank.
   A browser can restore a form field to empty (back/forward, autofill), and an
   empty number box looks like a missing quantity. This fills an empty or
   invalid add-to-cart quantity with its minimum, shows that minimum as the
   placeholder, and re-checks when the page is restored from the cache.
   Only add-to-cart forms: the cart's own quantity boxes may legitimately be 0. */
(function () {
  var SELECTOR = 'form[action*="/cart/add"] input[type="number"][name="quantity"]';

  function minimum(input) {
    var min = Number(input.min);
    return Number.isFinite(min) && min > 0 ? min : 1;
  }

  function fix(input) {
    var value = Number(input.value);
    if (input.value === '' || !Number.isFinite(value) || value < minimum(input)) {
      input.value = String(minimum(input));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function run() {
    document.querySelectorAll(SELECTOR).forEach(function (input) {
      if (!input.placeholder) input.placeholder = String(minimum(input));
      fix(input);
    });
  }

  document.addEventListener('focusout', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches(SELECTOR)) fix(target);
  });
  window.addEventListener('pageshow', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
